import { render } from "./ProjectOverviewTable.vue?vue&type=template&id=289825fb&scoped=true"
import script from "./ProjectOverviewTable.vue?vue&type=script&lang=js"
export * from "./ProjectOverviewTable.vue?vue&type=script&lang=js"

import "./ProjectOverviewTable.vue?vue&type=style&index=0&id=289825fb&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289825fb"]])

export default __exports__